//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const ProxyUsers = createAsyncThunk(
  "Patient/ProxyUsers",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingProxyUsers(""));
      const response = await UsePortalApi(
        `Patient/ProxyUsers`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        dispatch(
          gettingProxyUsersSuccess(response[0].entry)) 
      } else {
        dispatch(
          gettingProxyUsersFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingProxyUsersFailed(error));
    }
  }
);
const ProxyUsersSlice = createSlice({
  name: "ProxyUsers",
  initialState: {
    Proxy: null,
    isGettlistPrpxy: false,
    errorProxy: false,
  },
  reducers: {
    gettingProxyUsers: (state, action) => {
      state.Proxy = null;
      state.isGettlistPrpxy = true;
      state.errorProxy = false;
    },
    gettingProxyUsersSuccess: (state, action) => {
      state.Proxy = action.payload;
      state.isGettlistPrpxy = false;
      state.errorProxy = false;
    },
    gettingProxyUsersFailed: (state, action) => {
      state.Proxy = null;
      state.isGettlistPrpxy = false;
      state.errorProxy = true;
    },
    gettingProxyUsersClear: (state, action) => {
      state.Proxy = null;
      state.isGettlistPrpxy = false;
      state.errorProxy = false;
    },
  },
});
export const {
  gettingProxyUsers,
  gettingProxyUsersSuccess,
  gettingProxyUsersFailed,
  gettingProxyUsersClear,
} = ProxyUsersSlice.actions;
export default ProxyUsersSlice.reducer;
